module.exports = __webpack_public_path__ + "static/PcDeviceForRelease-5538e6361642b96ea5958d44cf645e18.png";